<template>
  <v-card> </v-card>
</template>

<script>
export default {
  name: "Footer",
};
</script>
